
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.967 15.5v8m15-1a3 3 0 00-3-3h-3.75a3 3 0 00-3-3H.967v6h15zm-9.75-3h3.75m2.5-16a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3.467 12.5a9 9 0 0118 0M2.467 14l-.482-.723A.5.5 0 012.4 12.5h20.133a.5.5 0 01.44.264.5.5 0 01-.024.513l-1.333 2a.5.5 0 01-.416.223H9.467","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    